import { extractionFieldLabel } from '@/app/document-review/review-labels'
import type { DocumentReviewProposalView } from '@/app/document-review/use-document-review'

export type RecordCardSpec = {
  title: string
  fieldLabels: Readonly<Record<string, string>>
}

export const RECORD_CARD_SPECS: Readonly<Record<string, RecordCardSpec>> = {
  purchase_order: {
    title: 'Purchase order',
    fieldLabels: {
      number: 'PO number',
      amount: 'Order total',
      incoterm: 'Incoterm',
      effectiveDate: 'Order date',
      endDate: 'Target delivery date',
      notes: 'Notes'
    }
  },
  invoice: {
    title: 'Invoice',
    fieldLabels: {
      number: 'Invoice number',
      amount: 'Invoice total',
      effectiveDate: 'Invoice date',
      endDate: 'Due date',
      notes: 'Notes'
    }
  },
  operational: {
    title: 'Operational',
    fieldLabels: {
      title: 'Title',
      number: 'Reference number',
      currency: 'Currency',
      amount: 'Amount',
      incoterm: 'Incoterm',
      effectiveDate: 'Start date',
      endDate: 'Delivery date',
      notes: 'Notes'
    }
  },
  payable: {
    title: 'Payable',
    fieldLabels: {
      number: 'Document number',
      amount: 'Amount owed',
      endDate: 'Due date',
      notes: 'Notes'
    }
  },
  proof_of_acceptance: {
    title: 'Proof of acceptance',
    fieldLabels: {
      effectiveDate: 'Acceptance date',
      notes: 'Notes'
    }
  },
  attachment: {
    title: 'Joins a record',
    fieldLabels: {
      amount: 'Contribution',
      effectiveDate: 'New effective date',
      endDate: 'New end date'
    }
  },
  information_request: {
    title: 'Asks a question',
    fieldLabels: {}
  },
  trader_document: {
    title: 'Upload',
    fieldLabels: {}
  }
}

const REFERENCE_LABELS: Readonly<Record<string, string>> = {
  externalReference: 'Printed reference',
  externalParentReference: 'Printed parent reference'
}

export function recordFieldLabel(kind: string, field: string): string {
  return RECORD_CARD_SPECS[kind]?.fieldLabels[field] ?? REFERENCE_LABELS[field] ?? extractionFieldLabel(field)
}

export function proposalFieldLabel(proposal: DocumentReviewProposalView, field: string): string {
  const record = proposal.record
  const setsAmount = field === 'amount' && record?.kind === 'attach' && record.updates?.amount !== undefined
  return recordFieldLabel(setsAmount ? 'purchase_order' : proposal.kind, field)
}

export function recordCardTitle(kind: string): string {
  return RECORD_CARD_SPECS[kind]?.title ?? kind
}
